module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "chapter-title---IVP",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('p', {
    staticClass: "veryfirst"
  }, [_c('b', [_vm._v("Part 1: Engaging Diverse Contexts")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1#_idTextAnchor001"
    }
  }, [_vm._v("1 Flexibility")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch2#_idTextAnchor009"
    }
  }, [_vm._v("2 Plausibility and Desirability")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3#_idTextAnchor017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Tangibility")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('b', [_vm._v("Part 2: Engaging the Spiritual But Not Religious")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4#_idTextAnchor030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 The Temple in the Desert and the Mysterious Massage")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5#_idTextAnchor041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Does Christianity Enable a Richer Spirituality?")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6#_idTextAnchor052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Inviting Others into an Experience of Christian Spirituality")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('b', [_vm._v("Part 3: Engaging Atheists")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7#_idTextAnchor057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Dawkins on a Bike (and Other Tales)")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch8#_idTextAnchor079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Isn’t Faith in God Irrational and Outdated?")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch9#_idTextAnchor117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Creating Safe Spaces for Exploring Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('b', [_vm._v("Part 4: Engaging Nominal Christians")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch10#_idTextAnchor119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 The Pimp, the Planter and Their Friends")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch11#_idTextAnchor137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Don’t You Realize I’ve Been There and Done That?")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch12#_idTextAnchor147",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Communities That Facilitate Rediscovering Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/epilogue#_idTextAnchor154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: Adventures with Ukrainian Comic Book Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appendix1#_idTextAnchor156",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 1: Comparative Statistics for Canada and the United Kingdom")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appendix2#_idTextAnchor163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 2: Did God Command Genocide?")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/appendix3#_idTextAnchor167",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix 3: Suggested Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/acknowledgements#_idTextAnchor168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#_idTextAnchor169",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/praise#_idTextAnchor322",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', {
    staticClass: "i"
  }, [_vm._v("The Myth of the Non-Christian")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author#_idTextAnchor323",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreIVP#_idTextAnchor324",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 63
// module chunks = 0